module.exports = __webpack_public_path__ + "static/img/companys.5e3cdcc3.svg";